import { DwMdEventHandler, DwMetaDataEventEntity, DwMdEventHandlerService, DwMdEventData, DwMdCreateEventData, DwMdEventType, DwMdUpdateEventData } from '@devwareapps/devware-cap';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from 'src/environments/environment';
import {MemoOfRecordEntity} from 'src/app/meta-data/app-meta-data.service'



@DwMdEventHandler({
key:'MorEventHandler',
name:'MOR Event Handler',
useDi:true,
})
@Injectable({
providedIn:'root'
})
export class MorEventHandler implements DwMdEventHandlerService {
  constructor(private http: HttpClient){

  }
handleEvent(event: DwMetaDataEventEntity, eventData: DwMdUpdateEventData): void {
  if (eventData.eventType == DwMdEventType.create){
    const memoOfRecordEntity : MemoOfRecordEntity = eventData.newItem;
    var configService: ConfigService = new ConfigService();
    const url = configService.config.wAppsApi + 'api/SendMorCreatedEmail';
    this.http.get(url + '?MorId=' + memoOfRecordEntity.MemoOfRecordId).subscribe(x => console.log(x));
  }
  else if (eventData.eventType == DwMdEventType.update) {
    const memoOfRecordEntity : MemoOfRecordEntity = eventData.newItem;
    var configService: ConfigService = new ConfigService();
    const url = configService.config.wAppsApi + 'api/SendMorModifiedEmail';
    this.http.get(url + '?MorId=' + memoOfRecordEntity.MemoOfRecordId).subscribe(x => console.log(x));
  }
  console.log(`EventServiceTest (Prototype) Event:  ${eventData.eventType} for ${eventData.itemName}`, eventData);
    }
}

